import { Alert, Stack, Typography } from "@mui/material";

/**
 * Lista de hallazgos de validación de temporada ({gravedad, mensaje, ids?}),
 * reusada por el diálogo de "validar-temporada" de Concursos, el diálogo de
 * transición de estado, y la pantalla de habilitar temporada nueva — mismo
 * shape en los tres lados. Gravedad 1 = error (bloquea), 2 = advertencia.
 */
export const HallazgosValidacionList = ({
  hallazgos = [],
  cantidadErrores = 0,
  cantidadAdvertencias = 0,
  mensajeVacio = "No se encontraron problemas."
}) => {
  if (hallazgos.length === 0) {
    return <Typography>{mensajeVacio}</Typography>;
  }

  return (
    <Stack spacing={1}>
      <Typography variant="body2">
        {cantidadErrores} error(es), {cantidadAdvertencias} advertencia(s).
      </Typography>
      {hallazgos.map((h, i) => (
        <Alert key={i} severity={h.gravedad === 1 ? "error" : "warning"}>
          {h.mensaje}
          {h.ids?.length > 0 ? ` (ids: ${h.ids.join(", ")})` : ""}
        </Alert>
      ))}
    </Stack>
  );
};

export default HallazgosValidacionList;
